export const RESULTS_LIMIT = 40;
